import { ApiClient } from '../../ApiClient';
import { ConnectionDTO } from '../dto/MarketplaceDTOs';
import { InventorySyncEventItem } from '@domain/connection/models/InventorySyncEvent';
import { FullSyncJob } from '@domain/connection/models/ImportJob';

export class WooCommerceConnectorDataSource {
  constructor(private api: ApiClient) {
  }

  async addWooCommerceConnection(url: string, consumerKey: string, consumerSecret: string): Promise<ConnectionDTO> {
    const response = await this.api.post<ConnectionDTO>('/connections/woocommerce', {
      url,
      consumer_key: consumerKey,
      consumer_secret: consumerSecret
    });
    return response.data;
  }

  async reconnect(connectionId: string, url: string, consumerKey: string, consumerSecret: string): Promise<ConnectionDTO> {
    const response = await this.api.post<ConnectionDTO>(`/connections/woocommerce/${connectionId}/reconnect`, {
      url,
      consumer_key: consumerKey,
      consumer_secret: consumerSecret
    });
    return response.data;
  }

  async syncAllOrders(connectionId: string): Promise<{ jobId: string }> {
    const response = await this.api.post<{ jobId: string }>(`/connections/woocommerce/orders/sync/all`, null, { params: { connectionId } });
    return response.data;
  }

  async syncNewOrders(connectionId: string): Promise<{ jobId: string }> {
    const response = await this.api.post<{ jobId: string }>(`/connections/woocommerce/orders/sync/new`, null, { params: { connectionId } });
    return response.data;
  }

  async syncProducts(connectionId: string): Promise<void> {
    await this.api.post(`/connections/woocommerce/products/sync`, null, { params: { connectionId } });
  }

  async fetchInventory(connectionId: string, page = 1): Promise<InventorySyncEventItem[]> {
    const response = await this.api.get<InventorySyncEventItem[]>(`/connections/woocommerce/products/inventory?connectionId=${connectionId}&page=${page}`);
    return response.data;
  }

  async syncFull(connectionId: string): Promise<FullSyncJob[]> {
    const response = await this.api.post<{ jobs: FullSyncJob[] }>(`/connections/woocommerce/sync/full`, null, { params: { connectionId } });
    return response.data.jobs;
  }
}
